import {Axios} from '@/axios/axios.js'
//地图的点
export const getMapDataPoint = (e) => {
  return Axios({
    url:"/dispatch/get_map_point_data",
    method:'put',
    data:e
  })
}
//任务列表
export const getMapData = (e) => {
  return Axios({
    url:"/dispatch/get_map_data",
    method:'put',
    data:e
  })
}
//获取公共数据 /dispatch/get_public_data
export const getPublicData = (e) => {
  return Axios({
    url:"/dispatch/get_public_data",
    method:'put',
    data:e
  })
}
//修改底部配置 /dispatch/cahnge_dispatch_setting
export const changeDspatchSet = (e) => {
  return Axios({
    url:"/dispatch/change_dispatch_setting",
    method:'put',
    data:e
  })
}
//获取部门司机 /dispatch/get_team_driver
export const getTeamDriver = (e) => {
  return Axios({
    url:"/dispatch/get_team_driver",
    method:'put',
    data:e
  })
}
//任务指派 /dispatch/assign_tasks
export const assignTasks = (e) => {
  return Axios({
    url:"/dispatch/assign_tasks",
    method:'put',
    data:e
  })
}
//搜索 /dispatch/search_content
export const searchList = (e) => {
  return Axios({
    url:"/dispatch/search_content",
    method:'put',
    data:e
  })
}
//排序 /dispatch/sort_task
export const sortTaskList = (e) => {
  return Axios({
    url:"/dispatch/sort_task",
    method:'put',
    data:e
  })
}


//dispatch_test  index.php/test/test_dist
export const dispatchTestData = (e) => {
  return Axios({
    url:"index.php/test/est_dist",
    method:'put',
    data:e
  })
}
//上传语音文件
export const uoloadAudio = (e) => {
  return Axios({
    url:"dispatch/upload",
    method:'POST',
    data:e
  })
}
//查询司机详情 /index.php/driver_group/get_worker_detail
export const searchDriverDetial = (e) => {
  return Axios({
    url:"index.php/driver_group/get_worker_detail",
    method:'POST',
    data:e
  })
}

//获取延迟的Ws
export const delayTaskApi = (e) => {
  return Axios({
    url:"index.php/TimerTask/delay_task",
    method:'get',
    data:e
  })
}
